import ApexGantt from "apexgantt";
import dayjs from 'dayjs';
import { useState } from 'react';
import { useEffect } from 'react';
import '../../css/estimation.css';
import { formatDateString } from '../../util/DateDataFormat';


const Gantt = (props) => {
  //console.log(props?.activities.map((act) => act.projectElements).flat());
  function getTaskTextByColumn(task, columnKey, inputDateFormat) {
    const taskColumnValue = task[columnKey];
    if (columnKey === "startTime") {
      return dayjs(taskColumnValue, inputDateFormat).format(inputDateFormat);
    }
    if (columnKey === "endTime") {
      return dayjs(taskColumnValue, inputDateFormat).format(inputDateFormat);
    }
    if (columnKey === "duration") {
      const startDate = dayjs(task[
        "startTime"
        /* StartTime */
      ], inputDateFormat);
      const endDate = dayjs(task[
        "endTime"
        /* EndTime */
      ], inputDateFormat);
      if (!task[
        "endTime"
        /* EndTime */
      ]) {
        return "0 d";
      }
      return `${endDate.diff(startDate, "d") + 1} d`;
    }
    return taskColumnValue;
  }

  const [options, setOptions] = useState({
    series: [],
    enableExport: false,
    viewMode: 'week',
    arrowColor: "#0D6EFD", 
    rowHeight: 30,
    enableTaskDrag: false,
    rowBackgroundColors: ["rgb(215, 235, 240)", "rgb(207, 241, 171)", "rgb(223, 223, 223)"], 
    barBackgroundColor: "#537CFA",
    tooltipTemplate: function(task, dateFormat) {
      //let format = "DD/MM/YYYY";
      const items = [
        `Nombre: ${task.name}`,
        `Inicio: ${task.startTime}`,
        `Fin: ${task.endTime}`
      ];
      if (task.dependency) {
        items.push(`Dependency: ${task.dependency}`);
      }
      return `<div>${items.join("<br/>")}</div>`;
    }
  });

  useEffect(() => {
    //console.log(props.activities);
    let series = [];
    if (props?.activities.length > 0) {
      props.activities.forEach((element, ind) => {
        series.push({id: element.id, startTime: formatDateString(element.estimatedStartDate, "yyyy-MM-dd"),
          endTime: formatDateString(element.estimatedFinishDate, "yyyy-MM-dd"),
          name: element.name
        });
        element[props.fields.phases].forEach(phase => {
          series.push({id: phase.id, startTime: formatDateString(phase.estimatedStartDate, "yyyy-MM-dd"),
            endTime: formatDateString(phase.estimatedFinishDate, "yyyy-MM-dd"),
            name: phase.name, parentId: element.id
          });
          phase[props.fields.tasks].forEach(task => {
            //console.log(task);
            series.push({id: task.id, startTime: formatDateString(task.estimatedStartDate, "yyyy-MM-dd"),
              endTime: formatDateString(task.estimatedFinishDate, "yyyy-MM-dd"),
              name: task.name, parentId: phase.id, dependency: task?.priorities.length > 0 ? task?.priorities[0].parents[0].data.id : ''
            });
          })
        })
      });
      setOptions({...options, series});
      //console.log(series);
    }
  }, [props.activities]);

  useEffect(() => {
    if (options.series.length > 0) {
      const gantt = new ApexGantt(document.getElementById('gantt-container'), options);
      gantt.render();
    }
  }, [options])

  return(
    <div id="gantt-container"></div>
  );
}

export default Gantt;

/*
[
      {
        id: 'a',
        startTime: '10-11-2024',
        endTime: '10-21-2024',
        name: 'task 1',
        progress: 65,
      },
      {
        id: 'aa',
        startTime: '10-11-2024',
        endTime: '10-21-2024',
        name: 'subtask 1.1',
        parentId: 'a',
        progress: 65,
      },
      {
        id: 'b',
        startTime: '10-01-2024',
        endTime: '10-19-2024',
        name: 'task 2',
        progress: 30,
      },
      {
        id: 'bb',
        startTime: '10-01-2024',
        endTime: '10-13-2024',
        name: 'subtask 2.1',
        parentId: 'b',
        progress: 65,
      },
      {
        id: 'cc',
        startTime: '10-14-2024',
        endTime: '10-19-2024',
        name: 'subtask 2.2',
        parentId: 'b',
        dependency: 'bb',
        progress: 0,
      },
      {
        id: 'c',
        startTime: '10-11-2024',
        endTime: '11-01-2024',
        name: 'task 100',
        progress: 65,
      },
      {
        id: 'dd',
        startTime: '10-11-2024',
        endTime: '10-26-2024',
        name: 'subtask 1.100',
        parentId: 'c',
        progress: 65,
      },
    ]
*/